/**
 * Returns a colour string.
 * @param {object} props
 * @param {string} props.theme
 * @param {string} props.variant
 * @returns {string}
 */

export const getVariantBgColor = (variant) => {
  const variantMap = {
    primary: 'primary.0',
    destructive: 'alert.3',
  };
  return variantMap[variant];
};
